import { render, staticRenderFns } from "./Entities.vue?vue&type=template&id=dad684e8&"
import script from "./Entities.vue?vue&type=script&lang=ts&"
export * from "./Entities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports